import { render, staticRenderFns } from "./SelectMethod.vue?vue&type=template&id=dd702a04&scoped=true"
import script from "./SelectMethod.vue?vue&type=script&lang=js"
export * from "./SelectMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd702a04",
  null
  
)

export default component.exports